var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v2.30.0-rc.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import '@/server/utils/setupEnv';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: `${ENV.config.SENTRY_DSN}`,
  environment: `${ENV.stage}`,
  release: `${ENV.commitSha}`,
});
